var React = require('react');

function NavRight (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"18","cy":"18","r":"18","fill":"white","fillOpacity":"0.61","key":0}),React.createElement("path",{"d":"M16.6567 13L22.3136 18.6569L16.6567 24.3137","stroke":"black","key":1})]);
}

NavRight.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = NavRight;

NavRight.default = NavRight;
